// 強い委譲ハンドラ（他のpreventDefaultより先に拾う）
document.addEventListener('change', function (e) {
  const sel = e.target && e.target.closest && e.target.closest('#blogFilterSelect');
  if (!sel) return;
  if (!sel.value) return;
  e.preventDefault(); // 念のため
  window.location.assign(sel.value);
}, true); // ← capture=true がポイント

// 何かが数秒後にselectを差し替える対策（軽量の監視）
(function ensureBlogFilterAlive() {
  const rebind = () => {
    const sel = document.querySelector('#blogFilterSelect');
    if (!sel) return;

    // 直接URLアクセス時の選択状態が外された場合に復元
    try {
      const path = decodeURI(location.pathname);
      const m = path.match(/\/blogs\/([^/]+)\/tagged\/([^/?#]+)/);
      if (!m) {
        sel.value = sel.querySelector('option[value^="/blogs/"][value$!="tagged"]').value || sel.value;
      }
    } catch(_) {}
  };

  // 初回 & 以降も定期チェック（2秒ごと。十分軽い）
  rebind();
  setInterval(rebind, 2000);

  // DOM差し替えが激しいテーマ用の最小監視
  const mo = new MutationObserver(rebind);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

